module.exports = __webpack_public_path__ + "img/hero.57c3bd35.png";